import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Sessions from '../components/Sessions';
import { SESSIONS } from '../data/sessions';
import './SessionsPage.css';

export default function SessionsPage() {
  const total = SESSIONS.reduce((n, s) => n + s.photos.length, 0);

  return (
    <>
      <Navbar />
      <main className="sessions-page">
        <header className="sessions-page__hero">
          <div className="container">
            <p className="eyebrow">In the field</p>
            <h1 className="sessions-page__title">Sessions in the Field</h1>
            <p className="sessions-page__sub">
              POSH awareness, IC training, and child safety sessions delivered on the ground,
              across workplaces and campuses.
              {total > 0 && (
                <> {' '}<span className="sessions-page__count">{SESSIONS.length} sessions · {total} photos</span></>
              )}
            </p>
          </div>
        </header>

        {SESSIONS.length > 0 ? (
          <Sessions showHeader={false} />
        ) : (
          <div className="container sessions-page__empty">
            <p>Session photos are coming soon.</p>
            <a href="/" className="btn btn-secondary">Back to home</a>
          </div>
        )}
      </main>
      <Footer />
    </>
  );
}
